module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame03-de7ad8f13d2980dbccc431fbcd5031cd.png";